import { Directive, HostListener, Input } from '@angular/core';
import { AzureTokenBlobPipe } from '../pipes/azureBlobToken.pipe';
import * as ADMIN_CONSTANT from '../../shared/constants/admin-constants';

@Directive({
  selector: '[appImageErrorHandler]',
})
export class ImageErrorHandlerDirective {
  @Input() defaultImage: any;
  loadOnce = false;
  @HostListener('error', ['$event'])
  onError(event) {
    if (this.defaultImage && !this.loadOnce) {
      // from HTML
      event.target.src = this.azureBlobToken.transform(this.defaultImage);
      this.loadOnce = true;
    } else {
      // this is executed the 2nd time when both above fails
      event.target.src = ADMIN_CONSTANT.DEFAULT_IMAGE_PATH.defaultUIImgPlaceholder;
      this.loadOnce = false;
    }
  }

  constructor(private azureBlobToken: AzureTokenBlobPipe) {}

  ngOnInit() {}
}
